import React from "react";
export default function Iframe({ url, height }) {
    if (!url)
        return React.createElement(React.Fragment, null,
            React.createElement("h4", null, "Ne\u012Fvestas iframe adresas"));
    return React.createElement(React.Fragment, null,
        React.createElement("iframe", { src: url, style: { display: 'block', height: height || 300 } }));
}
